import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Vault } from "lucide-react";
import { toast } from "sonner";
import { API, fmtErr } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ResetPassword() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await API.post("/auth/reset-password", { token, password });
      toast.success(t("auth.reset_done"));
      navigate("/login");
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center px-4" data-testid="reset-password-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="flex items-center gap-2 mb-6">
          <Vault className="h-6 w-6 text-emerald-600" />
          <span className="font-heading font-bold text-lg">{t("brand")}</span>
        </div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">{t("auth.reset_title")}</h1>
        <form onSubmit={submit} className="space-y-4 mt-6">
          <div>
            <Label htmlFor="rp-password">{t("auth.new_password")}</Label>
            <Input id="rp-password" data-testid="reset-password-input" type="password" required minLength={6}
              value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" />
          </div>
          <Button data-testid="reset-submit-button" type="submit" disabled={busy || !token}
            className="w-full bg-emerald-600 hover:bg-emerald-700 text-white h-11">
            {busy ? t("common.loading") : t("auth.reset_btn")}
          </Button>
        </form>
        <div className="mt-4 text-center">
          <Link to="/login" className="text-sm text-emerald-700 hover:underline">{t("auth.back_login")}</Link>
        </div>
      </div>
    </div>
  );
}
